<template>
	<!-- <div :class="['sk-avatar', { 'sk-avatar--large': large, 'sk-avatar--small': small, 'sk-avatar--margin-bottom': marginBottom }]" :style="style"></div> -->
	<transition name="vue-avatar" mode="out-in">
		<div class="avatar" :style="style" :key="loaded_src">
			<span v-if="!image_exists">{{ initials }}</span>
		</div>
	</transition>
</template>

<script>
import { mapGetters } from 'vuex'

const COLORS_HSL = [
	[6, 71, 60],
	[340, 85, 66],
	[291, 49, 60],
	[263, 49, 63],
	[232, 46, 64],
	[218, 93, 67],
	[187, 73, 70],
	[187, 73, 58],
	[175, 43, 50],
	[151, 44, 53],
	[88, 53, 59],
	[66, 73, 59],
	[51, 95, 53],
	[47, 100, 49],
	[40, 100, 50],
	[16, 100, 69],
	[0, 0, 76],
	[201, 17, 62],
	[17, 16, 56],
	[0, 0, 64],
	[233, 47, 79],
	[262, 49, 74],
	[0, 0, 76],
	[187, 73, 70],
	[15, 15, 69],
	[88, 52, 67],
]


export default {
	name: 'avatar',
	props: {
		name: {
			type: String,
			default: 'Idicare'
		},
		src: {
			type: String,
			default: null
		},
		colors: {
			type: Array,
			default() {
				return COLORS_HSL
			},
		},
		size: {
			type: Number,
			default: 50,
		},
		borderRadius: {
			type: Number,
			default: 50,
		},
		customStyles: {
			type: Object,
			default() {
				return {}
			},
		},
		delay: {
			type: Number,
			default: 0,
		}
	},
	data() {
		return {
			loaded_src: null,
			image_exists: false,
		}
	},
	methods: {
		/**
		* Attempt to load the image, if it succeed the letter avatar is replaced with the image
		*/
		loadImage() {
			setTimeout(() => {
				if (!this.src || this.src == '') {
					return
				}
				const img = new Image()
				img.onload = () => {
					if (window.location.href.startsWith('http://localhost:8081')) {
						this.loaded_src = `http://localhost:8080/files/users/${this.currentUser.uid}/files/${this.src}/`
					}
					else {
						this.loaded_src = `/api/files/users/${this.currentUser.uid}/files/${this.src}/`
					}
					this.image_exists = true
				}
				if (window.location.href.startsWith('http://localhost:8081')) {
					img.src = `http://localhost:8080/files/users/${this.currentUser.uid}/files/${this.src}/`
				}
				else {
					img.src = `/api/files/users/${this.currentUser.uid}/files/${this.src}/`
				}
			}, this.delay)
		},
		format(parts) {
			if (parts.length <= 3) {
				return parts
			}
			// We have more than 3 parts, let's keep only uppercased letters
			let initials = parts.filter(v => v === v.toUpperCase())
			// if we have more than one char we're good to go
			// if not we only keep the 2 first chars, and the last one
			return initials.length > 1
				? initials
				: [...parts.splice(0, 2), parts[parts.length - 1]]
		},
	},
	computed: {
		initials() {
			return this.format(this.name.replace(/[^a-zA-Z- ]/g, "").match(/\b\w/g)).join('').toUpperCase().substr(0, 2)
		},
		style() {
			const [hue, saturation, lightness] = this.background_color
			const text_lightness = lightness < 60 ? lightness - 20 : lightness + 25
			const default_styles = {
				display: 'inline-flex',
				backgroundColor: `hsl(${hue}, ${saturation}%, ${lightness}%)`,
				color: `hsl(${hue}, ${saturation}%, ${text_lightness}%)`,
				fontWeight: 'bold',
				alignItems: 'center',
				justifyContent: 'center',
				borderRadius: this.borderRadius + '%',
				lineHeight: '1',
				width: this.size + 'px',
				maxWidth: this.size + 'px',
				height: this.size + 'px',
				maxHeight: this.size + 'px',
				fontSize: Math.floor(this.size / 2.5) + 'px',
			}
			if (this.image_exists) {
				Object.assign(default_styles, {
					backgroundImage: `url(${this.loaded_src})`,
					backgroundSize: 'cover',
					backgroundPosition: 'top center',
				})
			}
			return Object.assign(default_styles, this.customStyles)
		},
		 background_color() {
			return this.colors[this.name.length % (this.colors.length)]
		},
		...mapGetters({
			currentUser: 'CURRENT_USER'
		})
	},
	mounted() {
		this.$nextTick(function () {
			if (this.src) this.loadImage()
		})
	},
	watch: {
		src(value) {
			this.image_exists = false
			this.$nextTick(function () {
				if (value) this.loadImage()
			})
		},
	}
}
</script>

<style scoped>
.avatar {
	box-shadow: rgba(0,0,0,0.15) 1px 1px 5px;
}
</style>



// WEBPACK FOOTER //
// src/modules/ui/Avatar.vue